import React, { createContext, useState } from "react";

export const SingleProductPageContextStart = createContext();

export default function SingleProductPageContext(props) {
  const [productDetail, setProductDetail] = useState({});

  return (
    <SingleProductPageContextStart.Provider
      value={{ productDetail, setProductDetail }}
    >
      {props.children}
    </SingleProductPageContextStart.Provider>
  );
}
